exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#thumbnail-image{max-width:400px}.preview{background:#e2f0f9;color:#32799a;margin-bottom:20px;padding:5px;text-align:center}", ""]);

// exports
